import React, { useState } from 'react'
import { Link, Text, Button, Flex } from '@clear/design-system'
import { StepTitle } from '@components/layout/Form'
import PageContent from '@components/layout/PageContent'
import { useRouter } from 'next/router'
import { DiscreteEvent, dispatchCustomEvent, KPI } from '@utils/customEvents'
import { Enrollment } from '@clear-denver/tpc-openapi-typescript'
import { getXCLEARCorrelationInfo } from '@clear-denver/tpc-openapi-typescript/build/utils'
import { enrollmentHelperClient } from '@api/enrollmentClient'

export default function CancelPage() {
  const router = useRouter()
  const { query } = router
  const enrollmentId = query.enrollmentId || ''
  const [isAppointmentCancelled, setIsAppointmentCancelled] = useState(false)
  const [showError, setShowError] = useState(false)

  const submitCancellation = async () => {
    const xCLEARCorrelationInfo = getXCLEARCorrelationInfo()
    const baseMetaData = {
      kpi: KPI.USER_INTERACTION,
      xCLEARCorrelationInfo,
      url: router.route,
    }
    try {
      dispatchCustomEvent(Enrollment.LogEntryLevelEnum.INFO, {
        payload: {
          message: 'Cancel appointment begin',
        },
        metadata: {
          ...baseMetaData,
          event: DiscreteEvent.CANCEL_APPOINTMENT_BEGIN,
        },
      })
      await enrollmentHelperClient.appointmentCancel_1({
        xCLEARCorrelationInfo,
        enrollmentId: enrollmentId as string,
      })
      dispatchCustomEvent(Enrollment.LogEntryLevelEnum.INFO, {
        payload: {
          message: 'Cancel appointment success',
        },
        metadata: {
          ...baseMetaData,
          event: DiscreteEvent.CANCEL_APPOINTMENT_SUCCESS,
        },
      })
      setIsAppointmentCancelled(true)
    } catch (error) {
      setShowError(true)
      dispatchCustomEvent(Enrollment.LogEntryLevelEnum.ERROR, {
        payload: {
          message: error?.message,
          stack: error?.stack,
        },
        metadata: {
          event: DiscreteEvent.DOCUMENT_CHECK_SUBMIT_FAILURE,
          ...baseMetaData,
        },
      })
    }
  }

  return (
    <PageContent>
      <StepTitle mb={10}>In-Person Appointment</StepTitle>
      <Flex flexDirection="column" alignItems="center">
        {!isAppointmentCancelled ? (
          <>
            <Text mb={5}>
              Are you sure you want to cancel your appointment?
            </Text>
            <Button
              onClick={submitCancellation}
              variant="primary"
              textProps={{ variant: 'regular' }}
            >
              Cancel My Appointment
            </Button>
          </>
        ) : (
          <>
            <Text variant="display" mb={5}>
              Appointment Successfully Cancelled
            </Text>
            <Text>
              If you would like to book another appointment please contact our
              support team at{' '}
              <Link
                variant="regular"
                color="brandDarkBlue"
                href="tel:1-888-831-9070"
              >
                {' '}
                1-888-831-9070
              </Link>
              .
            </Text>
          </>
        )}
        {!isAppointmentCancelled && showError ? (
          <Text mt={5} color="utilityDarkErrorRed">
            There was an error while cancelling your appointment. Please make
            sure to access this page directly from your appointment
            notification.
          </Text>
        ) : null}
      </Flex>
    </PageContent>
  )
}
